import React from "react";
import IntegrationsTab from "./IntegrationsTab";
import SsoTab from "./SsoTab";

/** Advanced — bundles Integrations + SSO together so the primary tab bar
 *  stays focused on Workspace · Billing · Brand Kit. */
export default function AdvancedTab({ isOwner }) {
  return (
    <div className="space-y-10" data-testid="advanced-tab">
      <section>
        <h2 className="font-heading font-black text-xl tracking-tight mb-1">Integrations</h2>
        <p className="font-mono text-[11px] text-zinc-500 mb-4">
          Connect Slack and the rest of your operating stack.
        </p>
        <IntegrationsTab isOwner={isOwner} />
      </section>
      <div className="border-t border-zinc-900" />
      <section>
        <h2 className="font-heading font-black text-xl tracking-tight mb-1">Single Sign-On (SSO)</h2>
        <p className="font-mono text-[11px] text-zinc-500 mb-4">
          Enterprise SAML 2.0 + SCIM provisioning. Sales-assisted enablement.
        </p>
        <SsoTab />
      </section>
    </div>
  );
}
